<template>
  <v-dialog max-width="554px" :model-value="show" :fullscreen="$vuetify.display.xs" persistent>
    <v-card @click="$emit('show-modal')" class="clickable cursor-pointer">
      <v-container class="pa-0">
        <OnexAlert :type="Notifications.success">
          {{ $t('L_phone_number_has_been_updated_successfully') }}
        </OnexAlert>
        <v-row column justify="space-between" class="text-center px-4">
          <v-col cols="12" class="mt-12 text-h1 successLabel">
            {{ $t('L_success_verify') }}
          </v-col>
          <v-col cols="12" class="mb-10 text-body font-weight-regular text-center">
            {{ $t('L_your_mobile_phone_has_been_successfully_updated_for_your') }}
          </v-col>
          <v-col cols="12">
            <OnexButton
              color="primary"
              block
              @click="closeSuccessVerifyPhone"
              class="btnWidth mb-10"
            >
              {{ $t('L_OK') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { Notifications, OnexAlert, OnexButton } from '@primerica/onex-ui-lib';
import { mdiCheckCircleOutline } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'SuccessVerifyPhone',
  components: {
    OnexButton,
    OnexAlert,
  },
  data: () => ({
    show: true,
    mdiCheckCircleOutline,
    Notifications,
  }),
  methods: {
    closeSuccessVerifyPhone() {
      this.$emit('close-success-verify-phone');
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.btnWidth {
  max-width: 288px;
  margin: auto;
}
</style>
